import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import { SingleSelectItem } from '../../../internal';
import styles from './styles.module.css';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectMobileModal(props) {
  const {
    open,
    onClose,
    options,
    onChange,
    value,
    title,
    dataTestId
  } = props;
  const handleChange = v => {
    if (onChange) {
      onChange(v);
    }
    onClose();
  };
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: true,
    open: open,
    onClose: onClose,
    title: title,
    width: 648,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['items'],
      role: "listbox",
      "data-testid": generateDataTestId(dataTestId, ['items']),
      children: options.map(option => {
        const selected = value === option.value;
        return /*#__PURE__*/_jsx("div", {
          className: styles['item'],
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected,
            onClick: () => {
              handleChange(option.value);
            },
            role: "option",
            "aria-selected": selected ? 'true' : undefined
          })
        }, String(option.value));
      })
    })
  });
}